/**
 * Public acquisition CTA policy.
 *
 * Marketing and upsell surfaces should import this contract instead of
 * spelling their own account/signup label or destination. Authentication that
 * is required to complete a protected action is a separate product flow and
 * should continue to use Clerk directly.
 *
 * Destination: the free PDF Studio workbench on the active brand's app host
 * (okraPDF: app.okrapdf.com, ParseGrid: app.parsegrid.ai).
 */
import { appUrl } from './brand';

export const PUBLIC_STUDIO_CTA = {
  label: 'Studio',
  get href() {
    return appUrl('/');
  },
};
